import React, {useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import { useAuth } from '../../../../hooks/useAuth';
import { Divider, Grid, Typography } from '@mui/material';
import moment from "moment-jalaali";
import { CssTextField } from '../../elements';
import {NotificationManager} from 'react-notifications';
import { sellMatDetailUpdate, sellMatDetailDelete, sellMatDetailInsert } from '../../../../services/material-services';
import { blue } from '@mui/material/colors';
import ProgressWait from '../../progress';
import DoNotStepIcon from '@mui/icons-material/DoNotStep';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import BookmarksIcon from '@mui/icons-material/Bookmarks';


export default function DialogDetailEdit(props) {
    const { authData, authDataLang } = useAuth()
    const { onClose, dataUserReq, row, open } = props
    // const [isAdmin, setIsAdmin] = useState(false)
    const [loading, setLoading] = useState(false)

    const [btnSectionID, setBtnSectionID] = useState(0)
    const [btnSection, setBtnSection] = useState('')
    const [entryTime, setEntryTime] = useState('')
    

    // const theme = useTheme()
    // const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

    useEffect(()=>{
        // if(authData?.user){
        //     setIsAdmin(authData.user?.profile?.is_permium)
        // }
        if(row?.id){
            setBtnSectionID(row?.id)
        }
        if(row?.bio_step){
            setBtnSection(row?.bio_step)
        }

        let dateNow = moment(new Date()).format('YYYY-M-D')
        if(row?.expire_time){
            dateNow = moment(row?.expire_time).format('YYYY-M-D')
        }
        let persianDate = moment(dateNow, 'YYYY-M-D').format('jYYYY/jM/jD')
        setEntryTime(persianDate)
    }, [authData, row])

   
    const handleClose = () => {
        onClose('selectedValue')
    }
    

    const handelSubmitDelete = async e => {
        e.preventDefault()
        setLoading(true)

        await sellMatDetailDelete(authData.token, btnSectionID)
        // console.log("addNewBuyMaterial", addNewBuyMaterial, btnSectionID)
        // if (addNewBuyMaterial){
        NotificationManager.success('جزئیات جدید از برنامه حذف شد')
        // }else{
        //     NotificationManager.error('متاسفانه خطایی در زمان حذف جزئیات وجود دارد')
        // }
        // const dataBack = { 'bio_step': btnSection, "expire_time": entryTime, "detail_id": btnSectionID}
        // handleResultBack(dataBack)
        handleClose()
        setLoading(false)
    }

    const handelSubmitInsert = async e => {
        e.preventDefault()
        setLoading(true)
        const dateMiladi = moment(entryTime, 'jYYYY/jM/jD').format('YYYY-M-D')
        const data = {'sell_mat': dataUserReq.id, 'bio_step':btnSection, 'expire_time': dateMiladi}
        let addNewBuyMaterial = ''
        if(btnSectionID <= 0){
            addNewBuyMaterial = await sellMatDetailInsert(authData.token, data)
        }else{
            addNewBuyMaterial = await sellMatDetailUpdate(authData.token, btnSectionID, data)
        }
        
        // console.log("addNewBuyMaterial", addNewBuyMaterial)
        if (addNewBuyMaterial){
            NotificationManager.success('جزئیات جدید به برنامه اضافه شد')
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان ثبت جزئیات وجود دارد')
        }
        handleClose()
        setLoading(false)
    }
    
    if (loading) return <ProgressWait statusWait={true}/>

    return (
        <React.Fragment>
            <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                    dir={authDataLang?.view_sts ? "rtl" : "ltr"}
                    fullWidth
                >
                <DialogTitle id="responsive-dialog-title" sx={{backgroundColor: blue[600]}}>
                    <Grid container spacing={1} alignItems='flex-end'>
                        <Grid item>
                            <BookmarksIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                        </Grid>
                        <Grid item xs={10}>
                            <Typography 
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h4"
                                color={blue[50]}
                                >
                                ذخیره کردن
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText>
                    <div>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <DoNotStepIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField  
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            مراحل*
                                        </Typography>
                                    )}
                                    fullWidth
                                    variant="standard" value={btnSection}
                                    onChange={ e => setBtnSection( e.target.value )} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <HourglassBottomIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10} sx={{fontFamily: 'b_mitra'}}>
                                <CssTextField  
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            تاریخ اتمام*
                                        </Typography>
                                    )}
                                    fullWidth
                                    variant="standard" value={entryTime}
                                    onChange={ e => setEntryTime( e.target.value )} />
                            </Grid>
                        </Grid>
                    </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {row?.id &&
                        <Button onClick={handelSubmitDelete} >
                            <Typography 
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color='secondary'
                                >
                                حذف
                            </Typography>
                        </Button>
                    }
                    
                    <Button autoFocus onClick={handleClose}>
                        <Typography 
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color='primary'
                            >
                            انصراف
                        </Typography>
                        
                    </Button>
                    <Button onClick={handelSubmitInsert} autoFocus>
                        
                        <Typography 
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color='primary'
                            >
                            ذخیره
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

DialogDetailEdit.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    // selectedValue: PropTypes.string.isRequired,
}
  